<button mat-flat-button color="primary" (click)="doOpenDatasourcesPickerDialog()" style="width: 100%; margin-top: 10px">
    Sélectionnez une source de données
</button>   